// @flow

import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'gatsby-plugin-intl'
import { FormattedMessageSanitized } from '../../FormattedMessageSanitized'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import { Container } from '../../../components/basic/Grid'
import SubpageHeroTeaser from '../../../components/SubpageHeroTeaser'
import Contacts from './../Contacts'

import messages from './PrivacyPage.lang'
import baseStyles from './PrivacyPage.scss'

type Props = {}

/* eslint-disable max-len */
const imageDesktop = (
  <StaticImage
    src="../../../images/heroteaser/imprint_heroteaser_bg_desktop.jpg"
    alt=""
    objectFit="cover"
    className="image"
  />
)
/* eslint-enable max-len */

const PrivacyPage = ({ styles }: StyleProps) => {
  const { formatMessage, locale } = useIntl()

  return (
    <div className={styles.root}>
      <SubpageHeroTeaser title={formatMessage(messages.pageTitle)} image={imageDesktop} imgAlt="office gallery" />
      <Container fluid>
        <Contacts />
        <div className={styles.text}>
          <FormattedMessageSanitized tagName="div" {...messages.text} values={{
            cookiehublink: <a
              href="https://www.cookiehub.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.btnLink}
            >
              https://www.cookiehub.com/privacy-policy
            </a>,
            gpolicy: <a
              href={"https://policies.google.com/privacy?hl=" + locale}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.btnLink}
            >
              https://policies.google.com/privacy?hl={locale}
            </a>,
            gtools: <a
              href={"https://tools.google.com/dlpage/gaoptout?hl=" + locale}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.btnLink}
            >
              https://tools.google.com/dlpage/gaoptout?hl={locale}
            </a>,
          }} />
        </div>
      </Container>
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(PrivacyPage)
